import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

/**
 * PreviewPage - Serves preview HTML directly from backend
 * 
 * This component fetches the preview HTML from the backend
 * and renders it in a full-page iframe for clean display.
 * 
 * Public URL: /preview/{leadId}
 * Backend endpoint: /api/preview/{leadId}
 */
export default function PreviewPage() {
  const { leadId } = useParams();
  const API_URL = process.env.REACT_APP_BACKEND_URL || "";
  const [error, setError] = useState(null);

  // The preview URL points to the backend API
  const previewUrl = `${API_URL}/api/preview/${leadId}`;

  useEffect(() => {
    // Set document title
    document.title = "Website Preview";
  }, []);

  if (error) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontFamily: "system-ui, sans-serif",
        color: "#ef4444"
      }}>
        {error}
      </div>
    );
  }

  // Render the preview in a full-page iframe
  // The iframe loads directly from the backend API
  return (
    <iframe
      src={previewUrl}
      title="Website Preview"
      onError={() => setError("Failed to load preview")}
      style={{
        width: "100vw",
        height: "100vh",
        border: "none",
        position: "fixed",
        top: 0,
        left: 0
      }}
    />
  );
}
